export default {
  credit: {
    detail: 'Detail',
    detailTitle: 'Credit Usage',
    transId: 'Transaction ID',
    transIdPlaceholder: 'Enter transaction ID',
    bizId: 'Business ID',
    bizIdPlaceholder: 'Enter business ID',
    bizType: 'Business Type',
    bizTypePlaceholder: 'Enter business type',
    search: 'Search',
    reset: 'Reset',
    ruleName: 'Rule Name',
    skuType: 'SKU Type',
    skuPrice: 'SKU Price',
    skuQuantity: 'SKU Quantity',
    changeDirection: 'Change Type',
    changeAmount: 'Change Amount',
    balanceAfter: 'Balance After',
    changeTime: 'Change Time',
    remark: 'Remark',
    increase: 'Increase',
    decrease: 'Decrease',
    getBalanceFailed: 'Failed to get credit balance',
    copied: 'Copied',
  },
};
